const mutations = {
    setDashboardOverview(state, payload) {
        console.log("Committing mutation setDashboardOverview with payload:", payload);
        state.stats = payload?.stats || {};
        state.otherData = payload?.otherData || {};
    },
};

export default mutations;
